var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right-bar__ruler source-code"},[_c('h3',{staticClass:"right-bar__header"},[_vm._v(_vm._s(_vm.$t('translation.sourceCode')))]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('textarea',{staticClass:"source-code__body",domProps:{"value":_vm.code}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15cfa1cb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Code/rightbar/SourceCode.vue
// module id = null
// module chunks = 